import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { getGeneralUtility } from '../../../actions/inventoryActions'

import UtilityView from '../../../containers/Inventory/Reports/Utility/Utility'

const Utility = () => {
    const [dateStart, setDateStart] = useState(new Date())
    const [dateEnd, setDateEnd] = useState(new Date())
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(getGeneralUtility(dateStart,dateEnd))
    
      return () => {
        
      }
    }, [dateStart,dateEnd])
    
  
    return (
        <UtilityView

            dateStart={dateStart}
            setDateStart={setDateStart}
            dateEnd={dateEnd}
            setDateEnd={setDateEnd}
        />
    )
}

export default Utility